// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { QuickstartEvent, State } from '../../../services/types.tsx';

export const dispatchEvent =
	(event: QuickstartEvent): Action<State> =>
	async ({ getState }) => {
		getState().onEvent?.(event);
	};
